import { render } from "./NumberChart.vue?vue&type=template&id=2817280a&scoped=true&ts=true"
import script from "./NumberChart.vue?vue&type=script&lang=ts"
export * from "./NumberChart.vue?vue&type=script&lang=ts"

import "./NumberChart.vue?vue&type=style&index=0&id=2817280a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2817280a"]])

export default __exports__